import api from './api';

// Court Records crawler (feat/court-crawler) — proposal confirmation,
// per-case coverage, run history. All staff-side; nothing here is
// portal-visible.
const courtRecordsService = {
  listIdentifiers: async (status) => {
    const res = await api.get('/court-records/identifiers',
      { params: status ? { status } : {} });
    return res.data.identifiers;
  },

  confirmMapping: async (identifierId, matterId) => {
    const res = await api.post(
      `/court-records/identifiers/${identifierId}/confirm`,
      { matter_id: matterId });
    return res.data;
  },

  ignoreIdentifier: async (identifierId) => {
    const res = await api.post(
      `/court-records/identifiers/${identifierId}/ignore`);
    return res.data;
  },

  getCoverage: async (caseId) => {
    const res = await api.get(`/court-records/cases/${caseId}/coverage`);
    return res.data;
  },

  getDocket: async (caseId) => {
    const res = await api.get(`/court-records/cases/${caseId}/docket`);
    return res.data;
  },

  listRuns: async (limit = 20) => {
    const res = await api.get('/court-records/runs', { params: { limit } });
    return res.data.runs;
  },

  triggerRun: async (downloadDocuments = true) => {
    const res = await api.post('/court-records/runs/trigger',
      { download_documents: downloadDocuments });
    return res.data;
  },

  listCaseNumbers: async (matterId) => {
    const res = await api.get(`/court-records/matters/${matterId}/case-numbers`);
    return res.data.case_numbers;
  },

  addCaseNumbers: async (matterId, caseNumbers) => {
    const res = await api.post(`/court-records/matters/${matterId}/case-numbers`,
      { case_numbers: caseNumbers });
    return res.data;
  },

  unlinkCaseNumber: async (identifierId) => {
    const res = await api.post(`/court-records/identifiers/${identifierId}/unlink`);
    return res.data;
  },

  // A4 — per-case client auto-visibility (attorney confirmation)
  getVisibility: async (caseId) => {
    const res = await api.get(`/court-records-visibility/${caseId}`);
    return res.data;
  },
  setVisibility: async (caseId, enabled) => {
    const res = await api.put(`/court-records-visibility/${caseId}`, { enabled });
    return res.data;
  },
};

export default courtRecordsService;
